import { RiCalendarLine, RiCopyrightLine, RiSearch2Line, RiAccountCircleFill } from "react-icons/ri";
import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import TableComponent from "./TableComponent";
import ModalComponent from "./ModalComponent";
import ListDocumentation from "./ListDocumentation";

registerLocale("es", es);
const MainForm = ({
  data,
  user,
  handleSearch,
  handleChange,
  handleOpenDetail,
  handleOpenItem,
  handleCloseDetail,
  handleCloseItem,
}) => {
  return (
    <div className="p-4 md:p-8 lg:p-12 bg-gray-100">
      {/* Title */}
      <div className="mb-8">
        <h1 className="text-3xl font-semibold">Guías de remisión</h1>
      </div>
      {/* Search */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-center mb-6">
        <form className="col-span-1 md:col-span-1">
          <div className="relative">
            <RiCalendarLine className="absolute left-2 top-3 z-10 text-green-600" />
            <DatePicker
              locale="es"
              name="startDate"
              className="bg-white-100 py-2 pl-8 pr-4 outline-none rounded-lg w-full"
              selected={data.form.startDate}
              dateFormat="dd/MM/yyyy"
              onChange={(event) => handleChange(event, "startDate")}
            />
          </div>
        </form>
        <form className="col-span-1 md:col-span-1">
          <div className="relative">
            <RiCalendarLine className="absolute left-2 top-3 z-10 text-green-600" />
            <DatePicker
              locale="es"
              name="endDate"
              className="bg-white-100 py-2 pl-8 pr-4 outline-none rounded-lg w-full"
              selected={data.form.endDate}
              dateFormat="dd/MM/yyyy"
              onChange={(event) => handleChange(event, "endDate")}
            />
          </div>
        </form>
        <form className="col-span-1 md:col-span-1">
          <div className="relative">
            <RiCopyrightLine className="absolute left-2 top-3 text-green-600" />
            <select
              type="text"
              className="bg-white-100 py-[10px] pl-8 pr-4 outline-none rounded-lg w-full"
              placeholder="Buscar"
              value={data.form.defaultEmpresa}
              onChange={(event) => handleChange(event, "defaultEmpresa")}
            >
              {user.empresas.map((item) => (
                <option key={item.abreviacion} value={item.abreviacion}>
                  {item.nombre}
                </option>
              ))}
            </select>
          </div>
        </form>



        {data.form.sucursales ?
        <form className="col-span-1 md:col-span-1">
          <div className="relative">
            <RiAccountCircleFill className="absolute left-2 top-3 text-green-600" />
            <select
              type="text"
              className="bg-white-100 py-[10px] pl-8 pr-4 outline-none rounded-lg w-full"
              placeholder="Buscar"
              value={data.form.defaultSucursal}
              onChange={(event) => handleChange(event, "defaultSucursal")}
            >
              {data.form.sucursales.map((item) => (
                <option key={item.Sucursal} value={item.Sucursal}>
                  {item.Sucursal}
                </option>
              ))}
            </select>
          </div>
        </form>
        : null}




        <form className="col-span-1 md:col-span-1">
          <div className="relative">
            <RiSearch2Line className="absolute left-2 top-3 z-10 text-white font-extrabold" />
            <button
              onClick={handleSearch}
              className="bg-green-600 py-2 pl-8 pr-4 outline-none rounded-lg w-full text-white font-bold"
            >
              <span>Buscar</span>
            </button>
          </div>
        </form>
      </div>

      {data.lista.data && data.lista.data.length > 0 ? (
        <div className="flex justify-center mb-6">
          <TableComponent
            dataComponent={data.lista}
            entity={"Cabecera"}
            handleOpenModal={handleOpenDetail}
          />
          {data.showDetail ? (
            <>
              <ModalComponent
                title={data.modalDetail.title}
                showModal={data.showDetail}
                handleCloseModal={handleCloseDetail}
              >
                <TableComponent
                  dataComponent={data.modalDetail.lista}
                  entity={"Detalle"}
                  handleOpenModal={handleOpenItem}
                />
              </ModalComponent>
            </>
          ) : null}
          {data.showItem ? (
            <ModalComponent
              title={data.modalItem.title}
              showModal={data.showItem}
              handleCloseModal={handleCloseItem}
              hideHeader={true}
            >
              <ListDocumentation
                items={data.modalItem.items}
                cabecera={data.modalItem.cabecera}
                itemSelect={data.modalItem.itemSelect}
                filtroTraduccion={data.modalDetail.filtroTraduccion}
                files={data.modalItem.files}
                defaultEmpresa={data.form.defaultEmpresa}
              />
            </ModalComponent>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};
export default MainForm;
